import { getMrnFromIdentifier, getPidFromIdentifier } from './StringUtil'

// Qualifying-relationship persons (`qr.*`) point at the same tree person as one of the main persons
// on the record, so sharing a PID with them is expected and must not count as a duplicate.
const QUALIFYING_RELATIONSHIP_PREFIX = 'qr.'

const isQualifyingRelationshipPerson = (person) => person?.id?.includes(QUALIFYING_RELATIONSHIP_PREFIX)

const getMainPersons = (persons) => (persons || []).filter((person) => !isQualifyingRelationshipPerson(person))

const findRepeatedValues = (values) => {
  const seen = new Set()
  const repeated = new Set()
  values.filter(Boolean).forEach((value) => {
    if (seen.has(value)) {
      repeated.add(value)
    }
    seen.add(value)
  })
  return repeated
}

// PIDs are stored as typed but resolved case-insensitively, so compare them in one case.
export const normalizePid = (pid) => pid?.toUpperCase()

export const getMainPersonPids = (persons) =>
  new Set(
    getMainPersons(persons)
      .map((person) => normalizePid(getPidFromIdentifier(person.identifiers)))
      .filter(Boolean)
  )

export const getDuplicatePersonIds = (persons) => {
  const mainPersons = getMainPersons(persons)
  return {
    pids: findRepeatedValues(mainPersons.map((person) => normalizePid(getPidFromIdentifier(person.identifiers)))),
    mrns: findRepeatedValues(mainPersons.map((person) => getMrnFromIdentifier(person.identifiers))),
  }
}

export const hasDuplicatePersonIds = (persons) => {
  const { pids, mrns } = getDuplicatePersonIds(persons)
  return pids.size > 0 || mrns.size > 0
}
